import { Website } from 'src/orchd-client';

export const isOwnWebsite = (orgId: string, website?: Website) => orgId === website?.orgId;
